<div id="banner-segofinance" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-container">
                    <div class="pretitle-container mb-lg-3">
                        <h1 class="h1-display primary-50">
                            Ahorra 
                            <br class="d-block d-sm-none"><span class="d-none d-sm-inline-block">·</span> 
                            Invierte 
                            <br class="d-block d-sm-none"><span class="d-none d-sm-inline-block">·</span> 
                            Rentabiliza
                        </h1>
                    </div>

                    <p class="p-display-bold primary-50 mb-2 d-none d-lg-block">
                        Grandes oportunidades de inversión al alcance de todos
                    </p>

                    <div class="subtitle-container d-none d-lg-block">
                        <p class="p2-medium primary-50">
                            Invierte con nosotros y construye una cartera diversificada desde una única plataforma
                        </p>
                    </div>
                </div>
            </div>

            <div class="mt-3 mt-lg-4">
                <app-btn-link [linkId]="'btn-banner-segofinance'" [linkStyle]="'secondary'" [linkUrl]="'/registro'" [linkTitle]="'Empieza a invertir'" [linkClass]="'me-3'"></app-btn-link>
                <div class="d-none d-lg-inline-block">
                    <a id="link-descubrenos-segofinance" routerLink="/quienes-somos"
                        class="mt-5 mt-lg-0 d-none d-lg-inline-flex align-items-center link2-bold primary-50"
                        title="Descúbrenos, somos diferentes">
                        <span class="me-2">Descúbrenos, somos diferentes</span>
                        <span class="material-symbols-outlined">arrow_forward</span>
                    </a>
                </div>
            </div>
        </div> 
    </div>
</div>